
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comming-soon",
      function () {
        return require("private-next-pages/comming-soon/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comming-soon"])
      });
    }
  